// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26-yv","right":"styles_right__R9dJx"};